import { default_dashboard } from '@core/breadcrumbs';

const module = default_dashboard
  .extend('autoinformer')
  .add('autoinformer.breadcrumb.title', { name: 'autoinformer.campaign.index' });

const campaigns_breadcrumbs = module
  .extend('autoinformer.campaign.index')
  .add('autoinformer.breadcrumb.campaign.index', { name: 'autoinformer.campaign.index' });

const create_campaigns_breadcrumbs = campaigns_breadcrumbs
  .extend('autoinformer.campaign.new')
  .add('autoinformer.campaign.create.title', { name: 'autoinformer.campaign.new' });

const edit_campaigns_breadcrumbs = campaigns_breadcrumbs
  .extend('autoinformer.campaign.edit')
  .add('autoinformer.campaign.edit.title', { name: 'autoinformer.campaign.edit' });

const task_campaigns_breadcrumbs = campaigns_breadcrumbs
  .extend('autoinformer.campaign.tasks')
  .add('autoinformer.campaign.tasks.title', { name: 'autoinformer.campaign.tasks' });

const task_create_campaigns_breadcrumbs = task_campaigns_breadcrumbs
  .extend('autoinformer.campaign.tasks.create')
  .add('autoinformer.breadcrumb.tasks.create', { name: 'autoinformer.campaign.tasks.create' });

const stats_breadcrumbs = module
  .extend('autoinformer.stats.type')
  .add('shared.breadcrumb.stats.title', { name: 'autoinformer.stats.index' });

const autoinformer_breadcrumbs = [
  campaigns_breadcrumbs,
  create_campaigns_breadcrumbs,
  edit_campaigns_breadcrumbs,
  task_campaigns_breadcrumbs,
  task_create_campaigns_breadcrumbs,
  stats_breadcrumbs
];

export { autoinformer_breadcrumbs };
